import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { ReadProjectType, CreateProjectType } from "@/types/projectType";

export const useProjectTypesDictionary = () => {
  const config = getDictionaryConfig<ReadProjectType, CreateProjectType>(
    Module.ProjectTypes,
  );
  return config;
};
